export const READ = `FIELDS/READ`
export const READ_SUCCEEDED = `FIELDS/READ_SUCCEEDED`
export const READ_FAILED = `FIELDS/READ_FAILED`

export const CREATE = `FIELDS/CREATE`
export const CREATE_SUCCEEDED = `FIELDS/CREATE_SUCCEEDED`
export const CREATE_FAILED = `FIELDS/CREATE_FAILED`

export const UPDATE = `FIELDS/UPDATE`
export const UPDATE_SUCCEEDED = `FIELDS/UPDATE_SUCCEEDED`
export const UPDATE_FAILED = `FIELDS/UPDATE_FAILED`

export const REMOVE = `FIELDS/REMOVE_ITEM`
export const REMOVE_SUCCEEDED = `FIELDS/REMOVE_ITEM_SUCCEEDED`
export const REMOVE_FAILED = `FIELDS/REMOVE_ITEM_FAILED`

export const CLEAR = `FIELDS/CLEAR`
